import type { ILineItemForm } from '@/Interfaces/CampaignManagement/LineItem.interface';
import LineItemSummaryService from '@/Services/CampaignManagement/LineItemSummary.service';
import { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import InfoTable, { rowspanTableMaxRows } from './InfoTable';

const DealGroupInfo = memo(() => {
  const { getValues } = useFormContext<ILineItemForm>();

  const values = getValues();
  const rows = LineItemSummaryService.getDealGroupsInfo(values);

  if (!rows.length) {
    return null;
  }

  return <InfoTable caption='Deal Groups' rows={rows} maxRows={rowspanTableMaxRows} />;
});

export default DealGroupInfo;
